// Javascript Document
  
(function($){
    $(function(){
        // Match_height

//         $('.all_gallery li').matchHeight();



        // Shop

        $('.topic_image, .topic_detail').addClass('active');

        if($('.topic_image, .topic_detail').hasClass('active')) {
            $('.topic_container').removeClass('no_mg');
            $('.topic_title h1').addClass('no_mg_bot');
        }
        else
        {
            $('.topic_container').addClass('no_mg');
            $('.topic_container > .page-width').addClass('d-none');
            $('.topic_title h1').removeClass('no_mg_bot');
        }



        // Accordion
        
        var myAccordion = new $.Zebra_Accordion('.accordion.one', {
            //collapsible: true,
            show: true,
          	show_speed: 500,
          	hide_speed: 500
        });



//         // Footer
//      $( document ).ready(function() {
//         if($(window).width() < 767) {        
//           $(".footer_con .footer_list").stop().slideUp(500);

// //             $(".footer_con:nth-child(2) .footer_ico, .footer_con:nth-child(2) .footer_wrap p").on("click", function() {
//           	$(".footer_con:nth-child(2) .footer_ico, .footer_con:nth-child(2) .footer_wrap p").on("click", function() {
//                 $(".footer_con:nth-child(2) .footer_list").stop().slideToggle(500);
//             });   

// //             $(".footer_con:nth-child(3) .footer_ico, .footer_con:nth-child(2) .footer_wrap p").on("click", function() {
//           	$(".footer_con:nth-child(3) .footer_ico, .footer_con:nth-child(3) .footer_wrap p").on("click", function() {
//                 $(".footer_con:nth-child(3) .footer_list").stop().slideToggle(500);
//             });
//         }
//       });
      
          // Footer
     $(document).ready(function() {
        if($(window).width() < 767) {        
//           $(".footer_con .footer_list").stop().slideUp(500);

// //             $(".footer_con:nth-child(2) .footer_ico, .footer_con:nth-child(2) .footer_wrap p").on("click", function() {
//           	$(".footer_con:nth-child(2) .footer_ico, .footer_con:nth-child(2) .footer_wrap p").on("click", function() {
//                 $(".footer_con:nth-child(2) .footer_list").stop().slideToggle(500);
//             });   

// //             $(".footer_con:nth-child(3) .footer_ico, .footer_con:nth-child(2) .footer_wrap p").on("click", function() {
//           	$(".footer_con:nth-child(3) .footer_ico, .footer_con:nth-child(3) .footer_wrap p").on("click", function() {
//                 $(".footer_con:nth-child(3) .footer_list").stop().slideToggle(500);
//             });
          
          $('.footer_wrap').click(function(){
              $(this).siblings('dd').slideToggle();
          })
        }
      });
      
      
      
		// Header
      	
      	$(".sh_cart").click(function(event) {
        	event.preventDefault();
      	});

    });
})(jQuery);